import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { Flex, Input, Button } from "antd"
import { Modal } from "ui/Modal"
import { Title } from "ui/Typography"
import styles from "./index.module.css"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"

const CreateCategoryModal = ({ open, onCancel, onSave }) => {
  const { t } = useTranslation()
  const [title, setTitle] = useState("")

  const handleSave = () => {
    if (title.trim()) {
      onSave(title.trim())
      setTitle("")
    }
  }

  const handleCancel = () => {
    setTitle("")
    onCancel()
  }

  return (
    <Modal open={open} onCancel={onCancel} maksClosable={false} centered footer={null} width={400} className={styles.createCategoryModal}>
      <Flex vertical gap={14}>
        <Flex justify="space-between" align="center">
          <Title level={4} className={styles.title}>
            {t("equipment.create_category_modal.title")}
          </Title>
        </Flex>

        <Flex vertical gap={8}>
          <LabeledField labelKey={t("equipment.create_category_modal.title_label")}>
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder={t("equipment.create_category_modal.title_placeholder")}
              className={styles.input}
              onPressEnter={handleSave}
            />
          </LabeledField>
        </Flex>

        <Flex gap={12} align="center" justify="space-between">
          <Button onClick={handleCancel} size="large" color="primary" variant="outlined">
            {t("equipment.create_category_modal.cancel_button")}
          </Button>
          <Button onClick={handleSave} disabled={!title.trim()} size="large" color="primary" variant="solid">
            {t("equipment.create_category_modal.save_button")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

CreateCategoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
}

export { CreateCategoryModal }
